import clsx from 'clsx';
import React from 'react';
import { toSentenceCase } from './util';

interface TextFieldProps {
  type: React.InputHTMLAttributes<HTMLInputElement>['type'];
  isRequired?: boolean;
  placeholder: string;
  error?: string | null;
  onChange: (text: string) => void;
  name: string;
  value: string;
}

export const TextField: React.FC<TextFieldProps> = ({
  type,
  placeholder,
  isRequired = false,
  error,
  onChange,
  name,
  value,
}) => {
  return (
    <div className="w-full flex flex-col gap-2 mt-5" id={`${name}-field`}>
      <div
        className={clsx(
          'w-full py-3 px-5 flex flex-col bg-gray-100 rounded-md relative',
          {
            'border-2 border-transparent focus-within:border-2 focus-within:border-blue-950':
              !error,
            'border-2 border-red-200': error,
          },
        )}
      >
        <label className="font-sans text-gray-250 font-regular text-sm">
          {toSentenceCase(name)}*
        </label>
        <input
          className="outline-none text-base md:text-base border-none w-full pt-1.5 m-0 bg-gray-100"
          type={type}
          placeholder={placeholder}
          required={isRequired}
          onChange={(e) => onChange(e.target.value)}
          name={name}
          value={value}
        />
      </div>
      {error ? <span className="text-red-200 pl-5">{error}</span> : null}
    </div>
  );
};
